<template>
	<div>
		<h2>Inquilinos</h2>
		<br>

		<a @click="$router.go(-1)">regresar</a>
		<br>
		<br>

		<input type='text' placeholder='BUSCAR' v-model='abuscar'  >
		<br><br>

		<router-link id="agregar":to="{name: 'agre-inqui'}">Agregar</router-link>
		<br>
		<br>

		<table class="table is-striped is-hoverable" id='inquilinos-lista' v-if="inquilinosTodos !=null" align="center"  >
			<tbody >	
				<tr>	
					<th>Nombre</th>
					<th>Mail</th>
					<th>Cel</th>
					<th>Status</th>
	
				</tr>

				<tr v-for="inquili in buscando">
					<td>{{inquili.nombreCompleto}}</td>
					<td>{{inquili.email}}</td>
					<td>{{inquili.celular}}</td>
					<td>{{inquili.status}}</td>
					<td>
						<router-link id="ver" :to="{name: 'ver-inqui', params:{id:inquili.id}}">Ver</router-link>
					</td>
					<td>
						<router-link id="editar" :to="{name: 'edi-inqui', params:{id:inquili.id}}">Editar</router-link>
					</td>
			   </tr>					   
			</tbody>
		</table>
		<span v-else><button class="button is-primary is-loading">Loading</button></span>

	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		  name: 'Inquilinos',
		  mounted(){
		  	this.getInquilinos();
		  },
		  props: ['vector'], 
		  data () {
		    return {
		      inquilinosTodos: null,
		      abuscar:''
		    }
		  },
		  methods:{
		  	getInquilinos(){
		 		  		// checa si tiene autorizacion
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Inquilinos')){
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}

		  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeInquilinos.php')
		  		     .then((respuesta) => {
		  		     	this.inquilinosTodos = respuesta.data;
		  		     	  		     	console.log('fffff ' + respuesta.data[1]['email']);

		  			 });
		  	}
	      },

	      computed:{
			 	buscando: function (){
			  		return this.inquilinosTodos.filter((item) =>  item.nombreCompleto.toUpperCase().includes(this.abuscar.toUpperCase()) 
			  			|| item.email.toUpperCase().includes(this.abuscar.toUpperCase()) 
			  			|| item.celular.toUpperCase().includes(this.abuscar.toUpperCase()) 
			  			|| item.status.toUpperCase().includes(this.abuscar.toUpperCase()) 
		 
			  		);
			  	}
		  }

	};

</script>

<style lang="scss">
	

</style>




// WEBPACK FOOTER //
// src/Inquilinos.vue